var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.5C3.44772 8.5 3 8.94772 3 9.5V19.5C3 20.0523 3.44772 20.5 4 20.5H20C20.5523 20.5 21 20.0523 21 19.5V9.5C21 8.94772 20.5523 8.5 20 8.5H4ZM1 9.5C1 7.84315 2.34315 6.5 4 6.5H20C21.6569 6.5 23 7.84315 23 9.5V19.5C23 21.1569 21.6569 22.5 20 22.5H4C2.34315 22.5 1 21.1569 1 19.5V9.5Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87868 3.37868C8.44129 2.81607 9.20435 2.5 10 2.5H14C14.7956 2.5 15.5587 2.81607 16.1213 3.37868C16.6839 3.94129 17 4.70435 17 5.5V21.5C17 22.0523 16.5523 22.5 16 22.5C15.4477 22.5 15 22.0523 15 21.5V5.5C15 5.23478 14.8946 4.98043 14.7071 4.79289C14.5196 4.60536 14.2652 4.5 14 4.5H10C9.73478 4.5 9.48043 4.60536 9.29289 4.79289C9.10536 4.98043 9 5.23478 9 5.5V21.5C9 22.0523 8.55228 22.5 8 22.5C7.44772 22.5 7 22.0523 7 21.5V5.5C7 4.70435 7.31607 3.94129 7.87868 3.37868Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.281ef2ebad680388c21ae9ae628bb38d.svg";
export { ForwardRef as ReactComponent };